import { render, staticRenderFns } from "./airship.vue?vue&type=template&id=5bfffde4&"
import script from "./airship.vue?vue&type=script&lang=js&"
export * from "./airship.vue?vue&type=script&lang=js&"
import style0 from "./airship.vue?vue&type=style&index=0&id=5bfffde4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports